/* eslint-disable import/prefer-default-export */

export class ApplicationError extends Error {}
